import React, { useState, useEffect, useContext } from 'react';
import { useFormik } from 'formik';
import { IoChevronBackCircle } from "react-icons/io5";
import { BsFillCursorFill } from "react-icons/bs";
import Select from "react-select";
import { AiOutlineClear } from "react-icons/ai";
import AirlinesService from '../../../services/airlines.servicse';
import UsersService from '../../../services/users.service';

import AppButton from 'components/FormsUI/AppButton/appButton';
import ToastContext from 'store/ToastContext';

const validate = values => {
    const errors = {};
    var patternUserName = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    var patternName = new RegExp(/^[a-zA-Z- ]+$/);
    var patternCallNumber = RegExp(/^\+(?:[0-9]?){6,14}[0-9]$/);

    if (!values.Airline) {
        errors.Airline = 'Required';
    }
    if (!values.FirstName) {
        errors.FirstName = 'Required';
    } else if (!patternName.test(values.FirstName)) {
        errors.FirstName = "Please enter valid First Name.";
    }
    if (!values.LastName) {
        errors.LastName = 'Required';
    } else if (!patternName.test(values.LastName)) {
        errors.LastName = "Please enter valid Last Name.";
    }
    if (!values.UserName) {
        errors.UserName = 'Required';
    } else if (!patternUserName.test(values.UserName)) {
        errors.UserName = "Please enter valid email address.";
    }
    if (!values.PhoneNumber) {
        errors.PhoneNumber = 'Required';

    } else if (!patternCallNumber.test(values.PhoneNumber)) {
        errors.PhoneNumber = "Please enter valid Phone Number.";
    }

    if (values.FaxNumber) {
        if (!patternCallNumber.test(values.FaxNumber)) {
            errors.FaxNumber = "Please enter valid Fax Number.";
        }
    }

    return errors;
}

export default function AdministratorDefinition(props) {
    const { openToast } = useContext(ToastContext);
    const [isLoading, setIsLoading] = useState(false);

    const [airlines, setAirlines] = useState([]);
   // const [selectedAirline, setSelectedAirline] = useState("");

    const fetchData = () => {
        AirlinesService.GetAirlinesWithoutAdministrator()
            .then(setAirlines)
            .catch(setAirlines);
    }

    useEffect(() => {
        fetchData();
    }, [])

    const clearfields = () => {
        handleSelectChange("")
        formik.setValues({
            UserName: '', FirstName: '', LastName: '', PhoneNumber: '', FaxNumber: '', Airline: ''
        });
    }

    function handleSelectChange(values) {
       // setSelectedAirline(values);
        formik.values.Airline = values.value;
    }

    const formik = useFormik({
        initialValues: {
            Airline: '',
            LastName: '', FirstName: '', UserName: '', PhoneNumber: '', FaxNumber: ''
        },
        validate,
        onSubmit: async (values) => {
            if (formik.isValid) {
                setIsLoading(true);
                values.Role = "admin";
                values.AirlineCode = values.Airline;
                const addUserResult = await UsersService.addAdmin(values);
                
                if (addUserResult.code === 0) {
                    openToast("User added", "success");
                } else {
                    openToast(`Error ${addUserResult.description}`, "error", {duration: 8000});
                }
                setIsLoading(false);
            }
        }
    })
    const backhandler = () => {
        props.history.goBack();
    }

    return (
        <div className="container py-5">
            <div className="row">
                <div className="col-md-10 mx-auto">
                    <h2>Administrator Definition</h2>
                </div>
            </div>
            <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <div className="col-md-10 mx-auto">
                        <div className="form-group row marginAtTop" >
                            <div className="col-sm-6">
                                <label htmlFor="Airline"><span className="requireField">*</span> Airline</label>
                                <Select
                                    options={airlines}
                                    value={airlines?.filter(option => option.value === formik.values.Airline)}
                                    onChange={(values) => handleSelectChange(values)} />
                                {formik.touched.Airline && formik.errors.Airline ? <div className="alert alert-danger">{formik.errors.Airline}</div> : null}
                            </div>
                            <div className="col-sm-6">
                                <label htmlFor="UserName"><span className="requireField">*</span> UserName</label>
                                <input name="UserName" id="UserName" type="text" onChange={formik.handleChange}
                                    value={formik.values.UserName}
                                    className="form-control" />
                                {formik.touched.UserName && formik.errors.UserName ? <div className="alert alert-danger">{formik.errors.UserName}</div> : null}
                            </div>
                        </div>

                        <div className="form-group row marginAtTop" >
                            <div className="col-sm-6">
                                <label htmlFor="FirstName"><span className="requireField">*</span> FirstName</label>
                                <input name="FirstName" id="FirstName" type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.FirstName}
                                    className="form-control" />
                                {formik.touched.FirstName && formik.errors.FirstName ? <div className="alert alert-danger">{formik.errors.FirstName}</div> : null}
                            </div>
                            <div className="col-sm-6">
                                <label htmlFor="LastName"><span className="requireField">*</span> LastName</label>
                                <input name="LastName" id="LastName" type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.LastName}
                                    className="form-control" />
                                {formik.touched.LastName && formik.errors.LastName ? <div className="alert alert-danger">{formik.errors.LastName}</div> : null}
                            </div>
                        </div>

                        <div className="form-group row marginAtTop" >

                            <div className="col-sm-6">
                                <label htmlFor="PhoneNumber"><span className="requireField">*</span> PhoneNumber</label>
                                <input name="PhoneNumber" id="PhoneNumber" type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.PhoneNumber}
                                    className="form-control" />
                                {formik.touched.PhoneNumber && formik.errors.PhoneNumber ? <div className="alert alert-danger">{formik.errors.PhoneNumber}</div> : null}
                            </div>
                            <div className="col-sm-6">
                                <label htmlFor="FaxNumber"> FaxNumber</label>
                                <input name="FaxNumber" id="FaxNumber" type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.FaxNumber}
                                    className="form-control" />
                                {formik.touched.FaxNumber && formik.errors.FaxNumber ? <div className="alert alert-danger">{formik.errors.FaxNumber}</div> : null}
                            </div>
                        </div>
                        <div className="rightBtn btn buttonRadius marginAtTop" >
                            <AppButton type="submit" label="Submit" color="success" icon={<BsFillCursorFill />} classes="margingRight" isLoading={isLoading}></AppButton>
                            <AppButton label="Clear" color="danger" icon={<AiOutlineClear />} action={clearfields} classes="margingRight"></AppButton>
                            <AppButton label="Back" icon={<IoChevronBackCircle />} action={backhandler}></AppButton>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}